import {styles} from './PopupBackground.style';

export function getModalStyle({showFullModal, showSuccessModal}: any) {
  if (showFullModal) {
    return styles.fullModalContainer;
  } else if (showSuccessModal) {
    return styles.successModalContainer;
  }
  return styles.contentContainer;
}
